import axios from 'axios';

const apiClient = axios.create({
  // baseURL: API_CONFIG.baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    // Убираем установку Authorization здесь, потому что токен может быть устаревшим
  },
});

// Интерцептор для авторизации
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;